module.exports = __webpack_public_path__ + "img/vote-8@2x.5341088d.png";